<template>
	<div>
		<!-- THE NEW LOGIC <vue-query-builder :rules="rules" v-model="query"></vue-query-builder> -->
		<tooltip label="Query Type" placement="right" v-show="dataset.ds_id > 0 && false">
			<select v-model="dataset.query_type" class="form-control">
				<option value="builder">{{ $t('Builder') }}</option>
				<!-- <option value="query">{{ $t('Query') }}</option> -->
			</select>
		</tooltip>

		<b-card v-show="dataset.query_type == 'builder' && dataset.ds_id > 0">
			<!-- <div class="h5">{{ $t('Query Groups', ':') }}</div> -->
			<div v-for="(group, group_index) in dataset.groups" :key="`query-group-${group_index}`">
				<b-card>
					<div class="row">
						<div class="col-12">
							<p class="h5">{{$t('queries for group')}}</p>
							<table class="table table-bordered table-striped table-sm">
								<tr>
									<th>{{ $t('Field') }}</th>
									<th>{{ $t('Relation') }}</th>
									<th>{{ $t('Variable') }}</th>
									<th>{{ $t('Default Value') }}</th>
									<th>{{ $t('actions') }}</th>
								</tr>

								<template v-if="group.length">
									<tr
										v-for="(elem, elem_index) in group"
										:key="`query-group-${group_index}-${elem_index}`"
									>
										<td>{{ elem.field_name }}</td>
										<td>{{ elem.rel }}</td>
										<td>{{ vars_ids_with_sender_vars[elem.var_id] }}</td>
										<td>{{ elem.value }}</td>
										<td>
											<button type="button" class="btn btn-link p-0 m-0 mr-2">
												<i
													@click="removeQueryGroupElement(group_index, elem_index)"
													class="fa fa-remove fa-lg"
													:title="$t('delete')"
												></i>
											</button>
										</td>
									</tr>
								</template>
								<template v-else>
									<tr>
										<td colspan="4">
											<div class="text-center">{{ $t('no data') }}</div>
										</td>
									</tr>
								</template>
							</table>
						</div>

						<div class="col-md-12">
							<button
								type="button"
								class="btn btn-sm btn-primary ml-0"
								@click="handleOnClickAddQuery(group_index)"
							>{{ $t('Add Query') }}</button>

							<button
								type="button"
								class="btn btn-sm btn-danger"
								@click="removeQueryGroup(group_index)"
							>{{ $t('Remove Group') }}</button>
						</div>
					</div>
				</b-card>
			</div>

			<button
				type="button"
				class="btn btn-primary ml-0"
				@click="addNewQueryGroup()"
			>{{ $t('add new query group') }}</button>
		</b-card>
		<p
			v-show="dataset.query_type == 'builder' && dataset.ds_id > 0"
			class="h4"
		>{{$t('response info')}}</p>
		<div v-show="dataset.query_type == 'builder' && dataset.ds_id > 0">
			<tooltip label="Response Via" placement="right">
				<select class="form-control" v-model="dataset.resp.via">
					<option value="text">{{ $t('Text') }}</option>
					<option value="quick_rep">{{ $t('Quick Replies') }}</option>
					<option value="card">{{ $t('Card (URL or List)') }}</option>
					<option value="video">{{ $t('Video') }}</option>
					<option value="Image">{{ $t('Image') }}</option>
					<option value="receipt">{{ $t('Receipt') }}</option>

				</select>
			</tooltip>
			<tooltip label="Data Limit" placement="right">
				<input
					name="data_limit"
					v-model.lazy="dataset.resp.limit"
					v-validate="'integer'"
					:class="{'form-control': true, 'is-invalid': errors.has('data_limit')}"
					type="text"
				/>
				<span
					v-if="errors.has('data_limit')"
					class="help is-danger invalid-feedback"
				>{{ $t(errors.first('data_limit')) }}</span>
			</tooltip>
			<tooltip label="text" placement="right" v-show="dataset.resp.via === 'text'">
				<input
					class="form-control"
					v-model="dataset.resp.title"
					:placeholder="$t('Title')"
					rows="1"
					v-autocomplete="autocomplete"
				/>
			</tooltip>
			<div v-if="dataset.resp.via == 'quick_rep'">
				<CommandResponseQuickReply
					:autoCompleteModules="autocomplete"
					:records="commandResponse.resp_quick_reply"
					:private_services="private_services"
					:public_services="public_services"
					:command_id_to_name="command_id_to_name"
					v-on:passQuickReplies="onQuickReplySave"
				>
				</CommandResponseQuickReply>
			</div>
			
			<!-- </CommandResponseQuickReply> -->
			<ComamandResponseCard
				v-show="dataset.resp.via === 'card'"
				:buttons="dataset.resp.buttons"
				:title="dataset.resp.title"
				:subTitle="dataset.resp.subtitle"
				:autoCompleteModules="autocomplete"
				@onNewButtonClick="push_button(dataset.resp.buttons)"
				@onRemoveButtonClick="(pos) => remove_button(pos, dataset.resp.buttons)"
			>
				<template slot="title">
					<tooltip label="value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="dataset.resp.title"
							:placeholder="$t('value')"
						/>
					</tooltip>
				</template>
				<template slot="subTitle">
					<tooltip label="value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="dataset.resp.subtitle"
							:placeholder="$t('value')"
						/>
					</tooltip>
				</template>
				<template slot="media">
					<tooltip label="value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="dataset.resp.media"
							:placeholder="$t('value')"
						/>
					</tooltip>
				</template>

				<template :slot="'button.' + ii" v-for="(button, ii) in  dataset.resp.buttons">
					<tooltip label="button label" placement="right" :key="'button.label.' + ii">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="button.item_label_key"
							:placeholder="$t('button label')"
						/>
					</tooltip>

					<tooltip label="button value" placement="right" :key="'button.value.' + ii">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="button.item_value_key"
							:placeholder="$t('button value')"
						/>
					</tooltip>
				</template>
			</ComamandResponseCard>
			<table
				v-show="dataset.resp.via == 'receipt'"
				class="table table-bordered table-striped table-sm"
			>
				<tr>
					<th>{{ $t('Name') }}</th>
					<td>
						<input
							type="text"
							class="form-control"
							v-model="dataset.resp.receipt.name"
							:placeholder="$t('name')"
							autocomplete="off"
							v-autocomplete="autocomplete"
						/>
					</td>
				</tr>
				<tr>
					<th>{{ $t('merchant') }}</th>
					<td>
						<input
							type="text"
							class="form-control"
							v-model="dataset.resp.receipt.merchant"
							:placeholder="$t('merchant')"
							autocomplete="off"
							v-autocomplete="autocomplete"
						/>
					</td>
				</tr>
				<tr>
					<th>{{ $t('order url') }}</th>
					<td>
						<input
							type="text"
							class="form-control"
							v-model="dataset.resp.receipt.order_url"
							:placeholder="$t('order url')"
							autocomplete="off"
							v-autocomplete="autocomplete"
						/>
					</td>
				</tr>
				<tr>
					<th>{{ $t('currency') }}</th>
					<td>
						<select v-model="dataset.resp.receipt.currency" class="form-control">
							<option value="EGP">{{ $t('EGP') }}</option>
							<option value="RSA">{{ $t('RSA') }}</option>
							<option value="USD">{{ $t('USD') }}</option>
						</select>
					</td>
				</tr>
				<tr>
					<th>{{ $t('payment method') }}</th>
					<td>
						<select v-model="dataset.resp.receipt.payment_method" class="form-control">
							<option value="cash">{{ $t('Cash') }}</option>
							<option value="visa">{{ $t('Visa') }}</option>
						</select>
					</td>
				</tr>
				<tr>
					<th>{{ $t('title coloumn') }}</th>
					<td>
						<select v-model="dataset.resp.receipt.elem_title_col" class="form-control">
							<option v-for="sc in dataset.ds_data.ds_schema" :value="sc.name">{{ sc.name }}</option>
						</select>
					</td>
				</tr>
				<tr>
					<th>{{ $t('price coloumn') }}</th>
					<td>
						<select v-model="dataset.resp.receipt.elem_price_col" class="form-control">
							<option v-for="sc in dataset.ds_data.ds_schema" :value="sc.name">{{ sc.name }}</option>
						</select>
					</td>
				</tr>
				<tr>
					<th>{{ $t('amount count coloumn') }}</th>
					<td>
						<select v-model="dataset.resp.receipt.elem_amount_col" class="form-control">
							<option v-for="sc in dataset.ds_data.ds_schema" :value="sc.name">{{ sc.name }}</option>
						</select>
					</td>
				</tr>
				<tr>
					<th>{{ $t('elem image col') }}</th>
					<td>
						<select v-model="dataset.resp.receipt.elem_image_col" class="form-control">
							<option v-for="sc in dataset.ds_data.ds_schema" :value="sc.name">{{ sc.name }}</option>
						</select>
					</td>
				</tr>
				<tr>
					<th>{{ $t('address') }}</th>
					<td>
						<input
							type="text"
							class="form-control"
							v-model="dataset.resp.receipt.address"
							:placeholder="$t('address')"
							v-autocomplete="autocomplete"
						/>
					</td>
				</tr>
				<tr>
					<th>{{ $t('shipping cost') }}</th>
					<td>
						<input
							type="text"
							class="form-control"
							v-model="dataset.resp.receipt.shipping_cost"
							:placeholder="$t('shipping cost')"
							v-autocomplete="autocomplete"
						/>
					</td>
				</tr>
				<tr>
					<th>{{ $t('total tax') }}</th>
					<td>
						<input
							type="text"
							class="form-control"
							v-model="dataset.resp.receipt.total_tax"
							:placeholder="$t('total tax')"
							v-autocomplete="autocomplete"
						/>
					</td>
				</tr>
			</table>
		</div>

		<b-modal
			size="lg"
			ref="groupQueryModal"
			:title="$t('Add new query group')"
			:no-close-on-backdrop="true"
			hide-footer
			@ok="handleOnmodalQueryGroupClick('ok')"
			@cancel="handleOnmodalQueryGroupClick('cancel')"
			@hide="handleOnmodalQueryGroupClick('hide')"
		>
			<div class="row">
				<div class="col-md-6">
					<tooltip label="Field" placement="right">
						<select class="form-control" v-model.lazy="datasetQueryGroupElement.field_name">
							<option value="0" disabled>{{ $t('None') }}</option>
							<option
								v-for="(sc, sc_i) in dataset.ds_data.ds_schema"
								:value="sc.name"
								:key="`sc${sc_i}`"
							>{{ sc.name }}</option>
							<option class="hl-opt" value="__status">{{ $t('__Status') }}</option>
							<option class="hl-opt" value="__sender_id">{{ $t('__Sender') }}</option>
						</select>
					</tooltip>
				</div>
				<div class="col-md-6">
					<tooltip label="Relation" placement="right">
						<select class="form-control" v-model.lazy="datasetQueryGroupElement.rel">
							<option
								v-for="(o, i) in $store.state.command.response.dataset.query.statements"
								:value="o.value"
								:key="`crdqs-${i}`"
							>{{o.label}}</option>
						</select>
					</tooltip>
				</div>
				<div class="col-md-6">
					<tooltip label="Variable" placement="right">
						<select class="form-control" v-model.lazy="datasetQueryGroupElement.var_id">
							<option value="0" disabled>{{ $t('None') }}</option>
							<option v-for="(v, _i) in vars" :value="v.var_id" :key="`v.var_id-${_i}`">{{ v.var_name }}</option>
							<option
								class="hl-opt"
								v-for="(sk, x) in Object.keys($store.state.sender_info)"
								:key="`$store.state.sender_info-${x}`"
								:value="sk"
							>{{ $t($store.state.sender_info[sk]) }}</option>
						</select>
					</tooltip>
				</div>
				<div class="col-md-6">
					<tooltip label="Default Value" placement="right">
						<input
							class="form-control"
							type="text"
							:placeholder="$t('Default Value')"
							v-model.lazy="datasetQueryGroupElement.value"
						/>
					</tooltip>
				</div>
				<div class="col-md-12">
					<button
						type="button"
						class="btn btn-sm btn-primary"
						@click="handleOnmodalQueryGroupClick('ok')"
					>{{ $t('Save') }}</button>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
// import VueQueryBuilder from "vue-query-builder";
// import DsQuery from "./DsQuery";
import axios from 'axios'
import ComamandResponseCard from '../../../components/ComamandResponseCard'
import CommandResponseQuickReply from '../../../components/CommandResponseQuickReply'

export default {
	name: "App",
	components: {
		// VueQueryBuilder,
		ComamandResponseCard,
		CommandResponseQuickReply
	},

	props: {
		commandResponse: {
			type: Object,
		},
	},

	data() {
		return {
			// rules: [],
			// query: {
			// 	logicalOperator: "all",
			// 	children: []
			// },

			autocomplete: {},
			private_services: [],
			public_services: [],
			command_id_to_name: {},
			vars_ids_with_sender_vars: {},
			command_id: null,
			vars: [],
			datasets_list: [],
			datasets_schema: {},
			datasetQueryGroupElement: {
				field_name: '0',
				rel: '=',
				var_id: '0',
				value: '',
				index: -1,
			}
		};
	},
	methods: {
		handleOnmodalQueryGroupClick(mode) {
			switch (mode) {
				case 'ok':
					if (
						this.datasetQueryGroupElement.index >= 0 &&
						this.datasetQueryGroupElement.field_name != '0' &&
						this.datasetQueryGroupElement.var_id != '0'
					) {
						this.addQueryElement(this.datasetQueryGroupElement.index)
						this.$refs.groupQueryModal && this.$refs.groupQueryModal.hide()
					}

					break

				default:
					break
			}
		},

		addNewQueryGroup() {
			this.dataset.groups.push([])
		},

		checkAutoCompleteHasVariableNearby() {
			this.setAutoCompeleteSchema()
		},

		get_command_vars() {
			return new Promise((resolve) => {
				axios
					.post('/command_var/get_all/' + this.command_id, {}, {})
					.then((res) => {
						if (res.data.status == 1) {
							this.vars = res.data.data
							// map id to names
							for (var _var in res.data.data) {
								this.vars_ids[res.data.data[_var].var_id] = res.data.data[_var].var_name
							}
							// Set Sender Info options
							this.vars_ids_with_sender_vars = {
								...this.vars_ids,
								...this.$store.state.sender_info,
							}
							this.setAutoCompeleteSchema()
						}
						resolve('success')
					})
					.catch(() => resolve('error'))
			})
		},
		
		dataSetHasNearByStatements(queryGroups) {
			const quieresRelation = queryGroups.reduce((prev, current) => {
				return prev.concat(
					current.reduce((cprev, ccurrent) => {
						return cprev.concat(ccurrent.rel)
					}, [])
				)
			}, [])

			return 0 <= quieresRelation.indexOf('nearby')
		},
		
		setAutoCompeleteSchema() {
			this.autocomplete = {
				...this.autocomplete,
				'@v': {
					icon: 'fa-at',
					short_descroption: this.$t('variables'),
					list: Object.values(this.vars_ids_with_sender_vars).concat(
						(() => {
							if (this.dataSetHasNearByStatements(this.dataset.groups.slice())) {
								return this.$store.state.command.response.dataset.query.autoCompleteExtraVariables
							}

							return []
						})()
					),
				},
				'@d': {
					icon: 'fa-database',
					short_descroption: (() => {
						return 'Dataset ' + (this.dataset.ds_data.ds_name || '')
					})(),
					list: (() => {
						return (
							this.dataset.ds_data.ds_schema ||
							[
								/* empty array required */
							]
						).reduce((a, b) => {
							return a.concat(b.name)
						}, [])
							
					})(),
				},
			}
		},

		get_datasets() {
			return new Promise((resolve, reject) => {
				axios
					.get('/dataset/get_list?type=dataset,menu', {})
					.then((res) => {
						if (res.data.status == 1) {
							this.datasets_list = res.data.private
							for (var _i in res.data.private) {
								this.datasets_schema[res.data.private[_i].ds_id] = {}
								for (var _s in res.data.private[_i].ds_schema) {
									this.datasets_schema[res.data.private[_i].ds_id][
										res.data.private[_i].ds_schema[_s]['name']
									] = res.data.private[_i].ds_schema[_s]['type']
								}
							}
						}
						resolve(res)
					})
					.catch((e) => reject(e))
			})
		},

		removeQueryGroup(group_index) {
			this.dataset.groups.splice(group_index, 1)
			this.checkAutoCompleteHasVariableNearby()
		},
		addQueryElement(group_index) {
			if (
				this.datasetQueryGroupElement.field_name != '0' &&
				this.datasetQueryGroupElement.var_id != '0' &&
				this.dataset.groups[group_index]
			) {				
				// get field type
				if (this.datasets_schema[this.dataset.ds_id][this.datasetQueryGroupElement.field_name] != undefined) {
					this.datasetQueryGroupElement.field_type = this.datasets_schema[this.dataset.ds_id][
						this.datasetQueryGroupElement.field_name
					]
				}
				// append field to the group
				this.dataset.groups[group_index].push(this.datasetQueryGroupElement)
				// reset form element
				this.datasetQueryGroupElement = {
					field_name: '0',
					var_id: '0',
					rel: '=',
					value: '',
					index: -1,
				}
				this.checkAutoCompleteHasVariableNearby()
			}
		},

		removeQueryGroupElement(group_index, element_index) {
			this.dataset.groups[group_index] && this.dataset.groups[group_index].splice(element_index, 1)
			this.checkAutoCompleteHasVariableNearby()
		},

		save() {
			var record = clone(this.commandResponse)
			record.resp_dataset = this.dataset

			if (this.data_source_error.length) return false

			var scopeFields = [];

			this.$validator.validateAll(scopeFields).then((success) => {
				if (success) {
					this.$root.loader = true
					axios
						.post('/command_response/save/' + this.command_id, {
							record: record,
						})
						.then((response) => {
							this.$root.loader = false
							if (response.data.status == 1) {
								this.$root.notify({
									message: this.$t('successfully updated'),
									status: 'success',
									area: 'topRight',
								})
							}
						})
						.catch(() => {
							this.$root.loader = false
							this.$root.notify({
								message: this.$t('server error'),
								status: 'error',
								autoHide: true,
								area: 'topRight',
							})
						})
				}
			})
		},

		getFields() {
			axios.get(`/dataset/browse/${this.dataset.ds_id}`).then((response) => {
				if (response.data.status) {			
					this.dataset.ds_data = response.data.data		
					// response.data.data.ds_schema.forEach(element => {
					// 	this.rules.push({
					// 		type: "custom-component",
					// 		id: element.name,
					// 		label: element.name,
					// 		operators: ["=", "!=", ">", "<", ">=", "<="],
					// 		component: DsQuery,
					// 		default: 50
					// 	})
					// });
				}
			})
		},
		onQuickReplySave(data){
			if(Array.isArray(data)){
				this.commandResponse['resp_quick_reply'] = data;
			} else {
				this.commandResponse['resp_quick_reply'] = [];
			}
			return true;
		},
		
		handleOnClickAddQuery(index) {
			this.$refs.groupQueryModal && this.$refs.groupQueryModal.show()
			this.datasetQueryGroupElement.index = index
		},
	},
	created() {
		console.log(this.commandResponse);
		
		// this.commandResponse.resp_dataset =  {
		// 	ds_id: 0,
		// 	ds_data: {},
		// 	query_type: 'builder',
		// 	groups: [[]],
		// 	query_syntax: [], // TODO: ask about these fields!!
		// 	resp: {
		// 		limit: 1,
		// 		via: 'text',
		// 		title: '',
		// 		subtitle: '',
		// 		media: '',
		// 		item_label: '',
		// 		item_value: '',
		// 		buttons: [
		// 			{
		// 				item_label_key: '',
		// 				item_value_key: '',
		// 			},
		// 		],
		// 		receipt: {
		// 			name: '',
		// 			merchant: '',
		// 			order_number: 0,
		// 			timestamp: 0,
		// 			order_url: 0,
		// 			currency: 'EGP',
		// 			payment_method: '',
		// 			dataset_id: 0,
		// 			elem_title_col: '',
		// 			elem_price_col: 0,
		// 			elem_amount_col: 1,
		// 			elem_image_col: '',
		// 			address: '',
		// 			sub_total: 0,
		// 			shipping_cost: 0,
		// 			total_tax: 0,
		// 			total_cost: 0,
		// 		},
		// 	},
		// };
		if (parseInt(this.$route.params.command_id) >= 1) {
			this.command_id = parseInt(this.$route.params.command_id);
		}

		this.get_command_vars();
		this.get_datasets();
		
		this.dataset.ds_id = this.$store.state.commandResponse.selected.resp_dataset_id // FIXME: it becomes `undefined` after refresh!
		
	},
	mounted() {
		this.getFields();
	},
	computed: {
		dataset() {
			return this.commandResponse.resp_dataset;
		}
	},
};
</script>
<style scoped>
	@import url('https://unpkg.com/vue-query-builder@0.8.2/dist/VueQueryBuilder.css');
</style>